import classNames from "classnames";
import React, { ReactNode, useEffect } from "react";
import config from "../../config/config.json";
import { SitePage } from "../../types/SitePage";
import "./FullPageLayout.scss";

interface FullPageLayoutProps {
  children: ReactNode;
  page: SitePage;
  title?: string;
}

const FullPageLayout: React.FC<FullPageLayoutProps> = ({
  children,
  page,
  title,
}) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} - ${config.appName}`;
    }
  }, [title]);

  const pageLayoutClass = classNames("full-page-layout", {
    [page]: true,
  });

  return (
    <div className={pageLayoutClass}>
      <main className="full-page-content">{children}</main>
    </div>
  );
};

export default FullPageLayout;
